module.exports = __webpack_public_path__ + "img/down-arrow-circle.3f156a3c.svg";